import { useEffect, useState } from 'react'


const Details = ({
    children = null,
    stepButtons = null,
    actionToPreviousStepButton = null,
    showPreviousStepButton = null,
    actionToNextStepButton = null,
    showNextStepButton = null,
    showCloseModalButtonInContent = null,
    extraClassName = null,
    setShowModal = null,
    setDetailsData = null
}) => {
    //const [showModal,setShowModal] = useState(true)
    

    const CloseModal = async () => {
        try {
            // Borra la info del estado donde se guardan los datos del registro que se está trabajando
            if (setDetailsData) {
                await setDetailsData(null)
            }
            
            await setShowModal(false)
        } catch (error) {
            
        }
    }

    // Detectar la tecla ESC para cerrar el modal
    useEffect(() => {
        const handleEscapeKey = async (event) => {
            if (event.key === 'Escape') {
                await CloseModal()
            }
        }
    
        window.addEventListener('keydown', handleEscapeKey)
    
        return () => {
            window.removeEventListener('keydown', handleEscapeKey)
        }
    }, [])


    return (
        <>
            <div className="cModal__Background" onClick={() => CloseModal()}></div>

            <div className="cModal__Container">
                {/* Botón flecha izquierda - Dispositivos grandes */}
                {stepButtons && (
                    showPreviousStepButton && (
                        <>
                            <div className="cModal__Container__Step--Lg">
                                <button type="button" className="Btn__Ztudia--PrimaryOutline cModal__Container__Step--Lg__Button" onClick={() => actionToPreviousStepButton()}><i className="bi bi-caret-left-fill"></i></button>
                            </div>
                        </>
                    )
                )}

                {/* Contenido del modal */}
                <div className={`cModal__Container__Content ${extraClassName && extraClassName}`}>
                    <button type='button' className='Btn__Ztudia--DangerOutline cModal__Container__Content__CloseButton' onClick={() => CloseModal()}>X</button>

                    {/* Contenido del modal si tiene otro tipo de contenido (controles, textos, etc.) */}
                    {children && ( children )}

                    {showCloseModalButtonInContent && (
                        <button type='button' className='Btn__Ztudia--DangerOutline cModal__Container__Content__Button--Center' onClick={() => CloseModal()}>Cerrar</button>
                    )}
                </div>

                {stepButtons && (
                    <>
                        {/* Botón flecha derecha - Dispositivos grandes */}
                        {showNextStepButton && (
                            <div className="cModal__Container__Step--Lg">
                                <button type="button" className="Btn__Ztudia--PrimaryOutline cModal__Container__Step--Lg__Button" onClick={() => actionToNextStepButton()}><i className="bi bi-caret-right-fill"></i></button>
                            </div>
                        )}

                        {/* Botones de flechas - Ambos dispositivos */}
                        <div className="cModal__Container__Step--Sm">
                            {showPreviousStepButton && (
                                <button type="button" className="Btn__Ztudia--PrimaryOutline cModal__Container__Step--Sm__Button" onClick={() => actionToPreviousStepButton()}>
                                    <i className="bi bi-caret-left-fill cModal__Container__Step--Sm__Button__Icon"></i>
                                    <span className='cModal__Container__Step--Sm__Button__Text'>Anterior</span>
                                </button>
                            )}
                            {showNextStepButton && (
                                <button type="button" className="Btn__Ztudia--PrimaryOutline cModal__Container__Step--Sm__Button" onClick={() => actionToNextStepButton()}>
                                    <i className="bi bi-caret-right-fill cModal__Container__Step--Sm__Button__Icon"></i>
                                    <span className='cModal__Container__Step--Sm__Button__Text'>Siguiente</span>
                                </button>
                            )}
                        </div>
                    </>
                )}
            </div>
        </>
    )
}

export { Details };